Hammer = require('public/bower_components/hammerjs/hammer')


touch = exports

# note: you can include multiple draggable selectors by comma-separating them
touch.draggableSel = '.ui-draggable, .ui-resizable-handle'
touch.textboxSel = 'input[type="text"], [contenteditable]'


touch.initialize = () ->
    self = touch

    h = Hammer(document)

    # Detect dragging events (we need this for map drawing tools to work)
    h.on 'dragstart', (event) ->
        if not event.gesture or event.gesture.pointerType is 'mouse'
            return

        if event.gesture.srcEvent.changedTouches?[0]?
            self._fireEvent event.target, 'mousedown', event.gesture.srcEvent.changedTouches[0]
            self._fireEvent event.target, 'mousemove', event.gesture.srcEvent.changedTouches[0]


    h.on 'drag', (event) ->
        if not event.gesture or event.gesture.pointerType is 'mouse'
            return

        if event.gesture.srcEvent.changedTouches?[0]?
            self._fireEvent event.target, 'mousemove', event.gesture.srcEvent.changedTouches[0]


    h.on 'dragend', (event) ->
        if not event.gesture or event.gesture.pointerType is 'mouse'
            return

        if event.gesture.srcEvent.changedTouches?[0]?
            self._fireEvent event.target, 'mouseup', event.gesture.srcEvent.changedTouches[0]

    # Done wif draggings


touch._fireEvent = (object, evt, touch) ->
    simulatedEvent = document.createEvent('MouseEvent')
    simulatedEvent.initMouseEvent(evt, true, true, window, 1,
        touch.screenX, touch.screenY,
        touch.clientX, touch.clientY, false,
        false, false, false, 0, null)

    object.dispatchEvent(simulatedEvent)
